module.exports = __webpack_public_path__ + "img/testing-idea-cards.f8f2e923.jpg";